export default "__VITE_ASSET__7bafd4fb__"